import { Component, OnInit } from '@angular/core';
import { environment } from 'apps/cinema1/src/environments/environment';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { LoaderComponent } from 'libs/shared/src/lib/component/loading/loading.component';

@Component({ standalone: false, selector: 'app-loader', templateUrl: './loading.component.html' })
export class CustomLoaderComponent extends LoaderComponent implements OnInit {
  constructor(protected loaderService: LoaderService) {
    super(environment, loaderService);
  }
}
